import { Modal } from '@mui/material';

import SearchEmails from './SearchEmails';
interface SearchEmailDialogProps {
  openDialog: boolean;
  closeDialog: () => void;
}
const SearchEmailDialog = ({ openDialog, closeDialog }: SearchEmailDialogProps) => {
  return (
    <Modal open={openDialog} onClose={closeDialog}>
      <SearchEmails closeDialog={closeDialog} />
    </Modal>
  );
};

export default SearchEmailDialog;
